import { createRoot } from "react-dom/client";
import { AppErrorBoundary } from "./components/AppErrorBoundary";
import MasterApp from "./MasterApp";
import { syncNativeAppClass } from "./lib/mobile-ui";
import "./styles/app.css";

syncNativeAppClass();

const host = window.location.hostname;
const isLoopback = host === "localhost" || host === "127.0.0.1" || host === "[::1]";
if (!isLoopback && window.location.protocol !== "https:") {
  const path = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  window.location.replace(`https://dashcam.mylunago.com${path}`);
} else {
  const el = document.getElementById("root");
  if (el) {
    createRoot(el).render(
      <AppErrorBoundary>
        <MasterApp />
      </AppErrorBoundary>,
    );
  }
}
